import React from 'react'
import { Grid, Typography, withStyles } from '@material-ui/core'
import { modalTitleIconedStyles } from 'asterX-UI/Modals/modals.styles'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { IconCloseButton } from 'asterX-UI/Buttons'
import PropTypes from 'prop-types'

const ModalTitleIconed = withStyles(modalTitleIconedStyles)(props => {
  const { children, classes, onClose, disableBtn = false, iconComponent, subtitle, ...other } = props

  const justifyContent = () => {
    if (!!iconComponent && !!onClose && !disableBtn) {
      return 'space-between'
    } else if (!!iconComponent && (disableBtn || !onClose)) {
      return 'flex-start'
    } else {
      return 'flex-end'
    }
  }

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Grid
        container
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        style={{ flexWrap: 'nowrap' }}
      >
        <Grid item>
          <Typography variant={'subtitle1'} className={classes.title} style={{ fontWeight: 700 }}>
            {children}
          </Typography>
        </Grid>
        <Grid item>
          <div
            className={classes.iconContainer}
            style={{
              justifyContent
            }}
          >
            {!!iconComponent && <div className={classes.icon}>{iconComponent}</div>}

            {onClose
              ? !disableBtn && <IconCloseButton aria-label="close" className={classes.closeButton} onClick={onClose} />
              : null}
          </div>
        </Grid>
        {!!subtitle && (
          <Grid item xs={12} style={{ marginTop: 16 }}>
            <Typography variant={'body1'} color={'textSecondary'}>
              {subtitle}
            </Typography>
          </Grid>
        )}
      </Grid>
    </MuiDialogTitle>
  )
})
export default ModalTitleIconed
ModalTitleIconed.propTypes = {
  onClose: PropTypes.func,
  iconComponent: PropTypes.node,
  children: PropTypes.any,
  disableBtn: PropTypes.bool,
  subtitle: PropTypes.string
}
